/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type RedemptionType = typeof RedemptionType[keyof typeof RedemptionType];


export const RedemptionType = {
  CODE: 'CODE',
  QR_CODE: 'QR_CODE',
  BARCODE: 'BARCODE',
} as const;
